import OrgPriceBenefitsPanel from './OrgPriceBenefitsPanel';

export default function CommercialAgreementPanel({ orgId }: { orgId: string }) {
  return <OrgPriceBenefitsPanel key={orgId} orgId={orgId} />;
}
